module.exports = __webpack_public_path__ + "202408221624/img/img_upload_draft_120@2x.9b96c54f.png";